var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_49_531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.9624 36.271C89.6707 38.0304 89.4613 39.7993 89.0756 41.5446C85.9918 55.3897 74.0944 66.0263 59.9459 67.6329C42.9395 69.5664 27.3914 58.9838 22.9693 42.4643C18.8176 26.928 26.681 10.1145 41.2953 3.30485C44.9821 1.55409 48.9541 0.481623 53.021 0.13878C53.1908 0.109608 53.3571 0.0631047 53.5173 0L58.2711 0C59.4237 0.171711 60.5786 0.322252 61.7289 0.515133C75.1105 2.74737 86.14 13.1488 89.0756 26.3447C89.4684 28.1065 89.673 29.9083 89.9624 31.6912V36.271ZM53.348 16.91V36.5509H73.0053V31.2843H58.5699V16.91H53.348Z",
    fill: "#396C03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.1424 67.4636L10.0392 83.6796L6.40033 80.029L22.4635 63.7988L26.1424 67.4636Z",
    fill: "#396C03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.5062 69.8793L40.0792 73.3888L26.1753 87.422L22.5953 83.8631L36.5062 69.8793Z",
    fill: "#396C03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.07808 67.4118L2.54977 63.9282C7.18205 59.2583 11.8253 54.5814 16.4795 49.8973L20.0078 53.3998L6.07808 67.4118Z",
    fill: "#396C03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.64121 50.0031L0 46.3831L12.6713 33.6365C13.8968 34.8549 15.1317 36.0781 16.289 37.2259L3.64121 50.0031Z",
    fill: "#396C03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.711 90.0001L40.0674 86.4106L52.7952 73.624L56.3847 77.2017L43.711 90.0001Z",
    fill: "#396C03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.9624,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d9ee1ca99fb781042a073ac3ff0da4be.svg";
export { ForwardRef as ReactComponent };